import { useTranslation } from "react-i18next";
import { photosLink } from "../business/photosLink";
import usePhotosEdition from "../business/usePhotosEdition";

const Thumbnail = ({
  id,
  slug,
  title,
  city,
  province,
  beginDate,
  endDate,
  disciplineId,
  link,
  logoLink,
  oldEventList,
  time,
}) => {
  const { t, i18n } = useTranslation();
  const { isDefaultEdition, photographer } = usePhotosEdition(
    slug,
    id,
    time === "past"
  );
  const cardLink = isDefaultEdition ? photosLink(slug) : link;

  const errorTitle = title ? title : t("title error");
  const location = city
    ? `${city}${province ? ` (${province})` : ""}`
    : province;

  const trimSize = 50;
  const trimmedTitle =
    errorTitle.length > trimSize
      ? errorTitle.substring(0, trimSize - 3) + "..."
      : errorTitle;

  const displayableBeginDate = new Date(beginDate)
    .toLocaleString()
    .split(",")[0];
  const displayableEndDate = new Date(endDate).toLocaleString().split(",")[0];

  const disciplineKey = `discipline_${disciplineId}`;
  const discipline =
    disciplineId && i18n.exists(disciplineKey) ? t(disciplineKey) : null;

  let displayableOldEventList = <></>;
  if (oldEventList && oldEventList.length > 0) {
    const linkList = oldEventList
      .map((event, index) => (
        <a key={index} href={event.link} className="">
          {event.year}
        </a>
      ))
      .reduce((a, b) => (
        <>
          {a} • {b}
        </>
      ));
    displayableOldEventList = (
      <p className="date pt-4">
        {t("editions")}: {linkList}{" "}
      </p>
    );
  }

  return (
    <div className="card text-center">
      <div className="cover">
        <a href={cardLink}>
          <img className="logo" alt="logo" src={logoLink} />
        </a>
        {discipline && <p className="category pt-2">{discipline}</p>}
        <a href={cardLink}>
          <h3>{trimmedTitle}</h3>
        </a>
      </div>
      <div className="card-body">
        <p className="date">
          {displayableBeginDate}
          {displayableBeginDate === displayableEndDate
            ? ""
            : " - " + displayableEndDate}
        </p>
        {location && <p className="date">{location}</p>}
        <a
          href={cardLink}
          className="btn btn-primary btn-md px-4 me-sm-3 fw-bold mt-2"
        >
          {time === "next" ? t("more info") : t("photos check")}
        </a>
        {displayableOldEventList}
      </div>
      <div className="card-photoby">
        <hr />
        <div className="d-flex mb-3 justify-content-center align-items-baseline">
          <p className="photographer mb-0">
            {t("photos from")} <strong>{photographer}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Thumbnail;
